import React from 'react';

import {
  Arrow,
  LazyWrap,
  BtnDetail,
  LazyCount,
  PillButton,
  PillAnchor,
} from './styles';
import { disabledValidator } from '../../config/buttonValidator';
import PropTypes from 'prop-types';
import { CapsuleButton } from '../../../../CommonComponents/Commons/commonComponents';

export const LazyLoadButton = function LazyLoadButton(props) {
  return (
    <LazyWrap onClick={props.lazyLoadHandle}>
      <BtnDetail>Load More Accounts</BtnDetail>
      <LazyCount>{props.lazyCnt}</LazyCount>
    </LazyWrap>
  );
};

LazyLoadButton.propTypes = {
  lazyCnt: PropTypes.number.isRequired,
  lazyLoadHandle: PropTypes.func.isRequired,
};

export const LinkTag = function LinkTag(props) {
  return <PillButton onClick={props.clicked}>{props.name}</PillButton>;
};

LinkTag.propTypes = {
  clicked: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};

export const FaDetailsButton = function FaDetailsButton(props) {
  return (
    <>
      <CapsuleButton
        text='View Full Details'
        onClick={props.routeTo}
        disabled={disabledValidator(props.data)}
      />
    </>
  );
};

FaDetailsButton.propTypes = {
  data: PropTypes.array,
  routeTo: PropTypes.func,
};
